import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import CourseReviewAverageScore from './courseReviewAverageScore';
import CourseReviewAverageScoreSkeleton from './courseReviewAverageScore/courseReviewAverageScoreSkeleton';
import CourseReviewList from './courseReviewList';
import CourseReviewListSkeleton from './courseReviewList/courseReviewListSkeleton';
import CourseReviewTitleSkeleton from './courseReviewTitleSkeleton';

type CourseReviewContentProps = {
  isLoading: boolean;
  handleFetchCourseReview: () => Promise<void>;
};

const CourseReviewContent: FC<CourseReviewContentProps> = ({ isLoading, handleFetchCourseReview }) => {
  const { t } = useTranslation('store_course');

  if (isLoading) {
    return (
      <>
        <CourseReviewTitleSkeleton />

        <Box display="grid" gridTemplateColumns={{ md: '35% 1fr', lg: '30% 1fr' }} gap={6} mt={3}>
          <CourseReviewAverageScoreSkeleton />

          <CourseReviewListSkeleton />
        </Box>
      </>
    );
  }

  return (
    <>
      <Typography variant="h4">{t('course_detail.course_review.title')}</Typography>
      <Divider sx={{ mt: 1, mb: 3 }} />

      <Box display="grid" gridTemplateColumns={{ md: '35% 1fr', lg: '30% 1fr' }} gap={6}>
        <CourseReviewAverageScore />

        <CourseReviewList handleFetchCourseReview={handleFetchCourseReview} />
      </Box>
    </>
  );
};

export default CourseReviewContent;
